function showFormatInfo(element) {
    try {
      const formatText = element.getAttribute('data-format-text');
      if (!formatText) return;
      
      Swal.fire({
        html: formatText,
        width: '600px',
        confirmButtonText: 'Close',
        confirmButtonColor: '#000000',
        customClass: {
          popup: 'format-info-popup',
          htmlContainer: 'format-info-content'
        }
      });
    } catch (error) {
      console.error('Error showing format info:', error);
    }
  }